import { ChackImageIsFile } from "src/helper/publicFunction";
import { GetFunction, PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetSessions =
  ({ callback, userId }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.ai_chat.sessions + `?userId=${userId}`;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      console.log({ responseresponse: response });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const GetChatMessages =
  ({ callback, session_id, offset = 1, rowsPerPage = 50 }) =>
  async (dispatch, getState) => {
    try {
      const queryParams = [];

      if (typeof offset !== "undefined") {
        queryParams.push(`page=${offset}`);
      }

      if (typeof rowsPerPage !== "undefined") {
        queryParams.push(`rowsPerPage=${rowsPerPage}`);
      }

      const link = `${UrlApi.ai_chat.messages}?${queryParams.join("&")}`;
      const data = {
        session_id: session_id,
      };
      const response = await PostFunction({
        Route: link,
        data: data,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });

      callback(response);
    } catch (err) {
      console.log({ err });
      callback(false);
    }
  };
